<template>
  <div class="MyRes fs20">
    <side_bar :links="links"></side_bar>
    <r_header v-if="!$store.state.mediaPhone"></r_header>
    <div class="detail" v-if="user">
      <div v-if="false" class="tips">
        白名单全国比赛4月开始报名和初赛，
        <a href="https://kcrhe.xetlk.com/s/4fu4fZ" target="_blank">
          点击报名初赛复赛辅导
        </a>
      </div>
      <div class="group">
        <div
          class="grp fs20"
          v-for="(v, slug) in gameState"
          :key="'grp-btn-'+slug"
          :class="{focus: rewardSlug == slug }"
          @click="focus(slug)">
          {{ dateTitle(slug) }}
        </div>
      </div>
      <div
        class="note fs18"
        v-for="(v, slug) in gameState"
        :key="'note-'+slug"
        :class="{display: rewardSlug == slug }"
      >
        <div class="content paper-tips" v-if="rw(slug) && v.state != 4">
          获取盖章纸质证书，请
          <a v-if="slug.split('-')[1] === '8'" target="_blank" href="https://appkgnjywge8466.h5.xiaoeknow.com/v1/goods/goods_detail/SPU_ENT_1694054835eslvFLMeJv3Os">点击链接</a>
          <span v-else> 扫码 </span>
          购买并填写地址。
          <img v-if="slug.split('-')[1] !== '8'" alt="" src="/oss/aiyouth2024/images/aiyouth-cert-qr.png" style="width: 100px; margin-left: 50px;" />
        </div>
        <div class="reward-image" v-if="rw(slug)">
          <div>点击证书下载电子版</div>
          <canvas :id="'canvas-'+slug" style="width: 50vw; cursor: pointer;"  @click="tryDownload" />
        </div>
        <div class="center" v-else>
          <div v-if="v.state === 0">
            您并未参加此轮比赛。
          </div>
          <div v-else>
            很遗憾您暂未获奖，请再接再厉，争取在下一轮比赛中取得好成绩！
          </div>
          <div class="badging">
            <div>
              大赛组委会
            </div>
            <div>
              {{ dateFooter(slug) }}
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="info" v-if="user.realname">
           <div v-for="(v, k) in info" class="column">
           <div class="first_line">{{k}}</div>
           <div>{{v}}</div>
           </div>
           </div> -->
      <!--      <div v-else class="certify">-->
      <!--        <certify></certify>-->
      <!--      </div>-->

    </div>

    <div class="detail" v-else>
      请先登录
    </div>
  </div>
</template>

<script>
import Certify from '@/components/score/Certify.vue'
import MyImage from '@/components/Image.vue'
import ProfImg from '@/assets/image/score/prof.png'
import SealImg from '@/assets/image/score/aiyouth_seal.png'
/* import SuccProfImg from '@/assets/image/score/succProf.jpg' */
import qrImg from '@/assets/image/score/qrcode.jpeg'
import finalPng from '@/assets/image/score/final.png'
import moment from 'moment'
import SideBar from '@/components/SideBar.vue';
import RHeader from '@/components/frontpage/Header.vue';

export default {
  name: 'EveryRewards',
  props: [],
  computed: {
    links () {
      return this.$store.state.sbar.linksFP
    },
    qr () {
      return qrImg
    },
    finalPng () {
      return finalPng
    },
    game_year() {
      return this.$store.state.game_slug.slice(0, 4)
    },
    gameState () {
      Object.filter = (obj, predicate) =>
        Object.assign({}, ...Object.keys(obj)
                      .filter( key => predicate(key, obj[key]) )
                      .map( key => ({ [key]: obj[key] }) ) );
      return  Object.filter(this.$store.state.auth.game_state, (v) =>{
        return !v.includes('aoc') && !v.includes('cq')
      })
    },
    rewardImg() {
      return ProfImg
    },
    sealImg () {return SealImg;
    },
    user() {
      return this.$store.state.auth.user;

    },
    group() {
      return ['小学组', '中学组', '开放组', '', '小初组']
    },
    info() {
      return {
        '姓名': this.user.realname,
        '身份证号': this.user.idcard,
        '地区': this.user.area,
        '组别': this.group[this.user.group-1],
        '参赛单位': this.user.organization? this.user.organization: '个人报名'
      }
    },
    username() {
      return this.user.realname || this.user.name
    },
    title() {
      return {
        'success': '恭喜你已成功晋级全国决赛',
        'failed':'很遗憾你没有晋级全国决赛'
      }
    },
  },
  data() {
    return {
      time: '11月20日',
      QQ: 'QQ群：926470859',
      reward: "计算机科学1级（CS1）证书",
      rewardSlug: ''
    }
  },
  methods: {
    tryDownload () {
      let slug = this.rewardSlug
      let canvas = document.getElementById('canvas-'+slug)
      let name = this.user.name
      new Promise(function(resolve){canvas.toBlob(resolve)}).then(function(blob) {
        let url = URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = '证书-'+name+'.png';
        a.click();
      })
    },
    rw (v) {
      if(!this.user) return false
      let vv = this.gameState[v]
      return vv.state >0 && vv.state < 4
    },
    rew (v) {
      let vv = this.gameState[v]
      if(['02', '12'].includes(v.split('-')[1])) {
        switch (vv.state) {
          case 1:
          case 2:
          case 3:
            return '全国' + vv.note
        }


      } else if(['8'].includes(v.split('-')[1])) {
        switch (vv.state) {
          case 1:
          case 2:
          case 3:
            return '全球' + vv.note
        }

      }
      else {
        switch (vv.state) {
          case 1:
          case 2:
          case 3:
            return '省级' + vv.note
          case 4:
            return ''
        }
      }
    },
    focus(f) {
      this.rewardSlug = f;
    },
    dateDate (slug) {
      return (new Date(...((slug || '').split('-')), 0))
    },
    dateTitle (slug) {
      const [year, round] = slug.split('-')
      switch(round) {
          case '01':
          return `${year-1}年下半年初赛`
          case '11':
          return `${year}年上半年初赛`
          case '02':
          return `${year-1}年下半年决赛`
          case '12':
          return `${year}年上半年决赛`
      }
    },
    dateFooter (slug) {
      const [year, round] = slug.split('-')
      switch(round) {
          case '01':
          return `${year-1}年11月`
          case '11':
          return `${year}年5月`
          case '02':
          return `${year-1}年12月`
          case '12':
          return `${year}年6月`
      }

    },
    async download() {
      let can = document.getElementById("canvas")
      let blob = await new Promise(resolve=>can.toBlob(resolve));
      let url = URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.href = url;
      a.download = '证书.png';
      a.click();
    },
    calcSN(rank) {
      let r = rank.toString()
      let len = 4-r.length;
      while(len > 0)
      {
        len -= 1;
        r = '0' + r;
      }
      return '2021' + (''+Math.random()).slice(2, 4) + r;
    },
    updateCert () {
      function  hashCode (str) {
        var hash = 0, i, chr;
        if (str.length === 0) return hash;
        for (i = 0; i < str.length; i++) {
          chr = str.charCodeAt(i);
          hash = ((hash << 5) - hash) + chr;
          hash |= 0; // Convert to 32bit integer
        }
        return hash;
      }
      let imgsrc = '/oss/aiyouth2024/images/AI2023Base.jpg'
      let displayName = this.user.name
      let slug = this.rewardSlug
      if (!slug) {
        return
      }
      let [year, _m] = slug.split('-')
      let month
      switch (_m) {
          case '01': month = 11; break;
          case '02': month = 12; break;
          case '11': month = 5; break;
          case '12': month = 6; break;
      }
      let reward = this.rew(slug)
      let group = this.group[this.user.group - 1]
      let sn = 'AI' + parseInt(month).toString(16) + [...year].reverse().join('') + ('0000000' + hashCode(displayName)).slice(-4)
      let time = `${year} 年 ${month} 月`
      let season = this.month2Season(year, month)
      if(imgsrc) {
        let canvas = document.getElementById('canvas-'+slug),
            ctx = canvas.getContext('2d');
        let seal = new Image();
        seal.src = '/oss/aiyouth2024/images/aiyouth-seal.png'
        seal.onload = () => {
          let img = new Image();
          img.src = imgsrc
          img.onload = () => {
            canvas.height = img.height;
            canvas.width = img.width;
            ctx.drawImage(img, 0, 0);
            
            ctx.drawImage(seal, 0, 0, seal.width, seal.height, 2650, 1600, 400, 400);
            ctx.font = "bolder 68pt simsun";
            ctx.fillStyle = "black";
            let length = ctx.measureText(displayName.toUpperCase()).width
            let posx = (img.width - length) / 2
            let y = img.height/2 - 200;
            console.log('pos:', posx, y, img.width, img.height)
            ctx.fillText(displayName.toUpperCase(), posx,y); // 放姓名
            
            ctx.font = "bolder 86pt simsun"
            ctx.fillStyle = "#c02729"
            length = ctx.measureText(reward).width
            posx = (img.width - length) / 2
            y = img.height / 2 + 300
            ctx.fillText(reward, posx, y )
            
            
            ctx.font = "46pt simsun"
            ctx.fillStyle = 'black'
            length = ctx.measureText(sn).width
            posx = img.width - 560
            y =  370
            ctx.fillText(sn, posx, y )
            
            ctx.font = "bold 48pt simsun"
            ctx.fillStyle = 'black'
            length = ctx.measureText(group).width
            posx = 1990
            y =  1210
            ctx.fillText(group, posx, y )
            
            ctx.font = "40pt dengxian"
            ctx.fillStyle = 'black'
            length = ctx.measureText(time).width
            posx = 2580
            y =  1955
            ctx.fillText(time, posx, y )
            
            
            ctx.font = "50pt dengxian"
            posx = 1150
            y = 1107
            ctx.fillText(season, posx, y)
            
            /*
               new Promise(function(resolve){canvas.toBlob(resolve)}).then(function(blob) {
               let url = URL.createObjectURL(blob);
               let a = document.createElement('a');
               a.href = url;
               a.download = '证书-'+name+'.png';
               a.click();
               })
             */
          }
        }
      }
    },
    month2Season (year, month) {
      const numberMonth = parseInt(month)
      if (numberMonth >=12 || numberMonth <=2) {
        return `${year} 年冬季`
      } else if (numberMonth >=3 && numberMonth <=5) {
        return `${year} 年春季`
      } else if (numberMonth >= 6 && numberMonth <=8) {
        return `${year} 年夏季`
      } else {
        return `${year} 年秋季`
      }
    },
    updateReward () {
      console.log('update reward')
      // this.passed = !this.passed;
      let that = this;
      let slug = this.rewardSlug
      if(!this.rw(slug)) return;
      let canvas = document.getElementById('canvas-'+slug);
      let ctx = canvas.getContext('2d');
      let img = new Image();
      if(this.gameState[slug].state === 4) {
        img.src = `/oss/aiyouth2023/images/rewardNext.png`
      } else {
        img.src = `/oss/aiyouth2023/images/reward2023.png`
      }
      if(slug.split('-')[1] === '8') {
        img.src = `/oss/aiyouth2023/images/cq-notiy.png`
      }
      img.onload = () => {
        let reward = that.reward;
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        ctx.font = "bolder 24pt simsun";
        ctx.fillStyle = "#dda06d";
        /* this.user.name = '青赛青赛' */
        let len = this.user.name.length
        const allChar = /^[\x00-\x7F]*$/.test(this.user.name)
        let posx = 120+ (180 - len*(allChar ? 30 : 72))/2
        if (allChar) {
          ctx.font = "bolder 20pt simsun";
        }

        let posy = 128
        if(slug.split('-')[1] === '8') {
          posy= 156
        }
        ctx.fillText(this.user.name, posx,posy);

        ctx.fillStyle = "#623a1a";
        ctx.font = "24pt simsun";

        posx = 225
        posy= 182
        if(month === '8') {
          ctx.font = "20pt simsun";
          posx= 200
          posy= 202
        }
        ctx.fillText(this.dateTitle(slug), posx, posy);

        ctx.font = '900 46pt nsimsun';
        ctx.fillStyle = '#d0a06f';
        let rw =  this.rew(slug);
        len =rw.length;
        posx = 400 - len*32;
        posy = 380

        if(slug.split('-')[1] === '8') {
          posy = 350
        }
        ctx.fillText(rw, posx, posy)
      }
    },
  },
  components:{
    r_header: RHeader,
    side_bar: SideBar,
    my_image: MyImage
  },
  watch: {
    rewardSlug () {
      /* this.updateReward(); */
      this.updateCert()
    },
    gameState () {
      this.rewardSlug = Object.keys(this.gameState)?.[0];
    }
  },
  mounted()
  {
    if(!this.user) {
      this.$router.push({name:'account', params:{type:'login'}})
    }
    this.rewardSlug = Object.keys(this.gameState)?.[0];
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.download{
  cursor: pointer;
}
.detail{
  margin-top: 5vh;
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content:center;
  position: relative;
  margin-bottom: 2vw;
}
.success, .failed{
  color: white;
  background-size: 60vw;
  width: 60vw;
  height: 10vw;
  display:flex;
  justify-content:center;
  align-items:center;
  font-size: 2.3vw;
}
.success{
  background-image: url(~@/assets/image/score/success.png);
}
.failed{
  background-image: url(~@/assets/image/score/failed.png);
}
.info{
  background-image: url(~@/assets/image/score/bg-myinfo.png);
  background-size: 62.3vw;
  width: 62.3vw;
  height: 10.78vw;
  color: white;

  margin-top:4vw;
  box-sizing: border-box;
  padding-left: 4.375vw;
  padding-right: 5.4vw;
  padding-top:1.15vw;
  padding-bottom: 3.125vw;
  display: flex;
}
.column{
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  border-right: solid 1px #7ec5ff;
}
.column:last-child{
  border-right: none !important;
}
.column>div{
  height: 3.25vw;
  display:flex;
  justify-content:center;
  align-items:center;
}
.first_line{
  border-bottom: solid 1px #7EC5FF;
  width: 100%;
}
.certify{
  position: absolute;
  background-color: rgb(255, 255, 255);
  border-radius: 5px;
  box-sizing: border-box;
  padding: 6.3vw 5vw 1vw 2.6vw;
  box-shadow: 1px 1px 5px rgba(0,0,0,0.1);
  height: 100%;
}
.note .content span{
  color:#FE2121;
}
.note .name{
  color: #2F2E38;
  font-weight: 600;
}
.note .content{
  color: #585668;
}
.note .badging{
  color: #585668;
  align-self: flex-end;
}
.note{
  display: none;
  flex-direction: column;
  align-items:flex-start;
  width: 46vw;
}

.note.display {
  display: flex;
}

.reward-image{
  margin-top: 3vw;
  display:flex;
  align-items:center;
  flex-direction: column;
}

.important{
  font-weight: bold;
  color: #405aee;
  display: flex;
  align-items: center;
  margin-top: 1em;
  flex-direction: column;
}
.content{
  text-indent: 2em;
}
.group{
  display: flex;
  align-items:center;
  justify-content: space-around;
  width: 100vw;
  border-bottom: 1px dashed black;
  margin-bottom: 1.5625vw;
  margin-top: 5vw ;
}
.grp{
  line-height: 2.5vw;
}
.focus{
  border-bottom: 1px solid black;
  color: #4411FF;
}
</style>
